import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import AdminLayout from './components/AdminLayout';
import ErrorBoundary from './components/ErrorBoundary';
import { AuthProvider } from './context/AuthContext';
import { StoreProvider } from './context/StoreContext';
import { TrackingProvider } from './context/TrackingContext';

// 前台頁面
import Home from './pages/Home';
import ProductList from './pages/ProductList';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import OrderComplete from './pages/OrderComplete';
import OrderStatus from './pages/OrderStatus';
import ShoppingGuide from './pages/ShoppingGuide';
import ReturnPolicy from './pages/ReturnPolicy';
import Login from './pages/Login';
import MemberCenter from './pages/MemberCenter';
import NotFound from './pages/NotFound';

// 後台頁面
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProducts from './pages/admin/AdminProducts';
import AdminOrders from './pages/admin/AdminOrders';
import AdminAnalytics from './pages/admin/AdminAnalytics';
import AdminSettings from './pages/admin/AdminSettings';
import AdminCategories from './pages/admin/AdminCategories';
import NotificationSettings from './pages/admin/NotificationSettings';
import AdminRemarketing from './pages/admin/AdminRemarketing';
import AdminMembers from './pages/admin/AdminMembers';

// 後台路由包裝器 (需要登入)
const AdminRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('admin_token');
  if (!isLoggedIn) {
    return <Navigate to="/admin" replace />;
  }
  return <AdminLayout>{children}</AdminLayout>;
};

function App() {
  return (
    <AuthProvider>
      <StoreProvider>
        {/* 動態載入所有追蹤代碼 (GTM, GA4, FB Pixel, TikTok) */}
        <TrackingProvider>
          <Routes>
        {/* 後台登入頁 (不需要 Layout) */}
        <Route path="/admin" element={<AdminLogin />} />

        {/* 後台路由 (使用 AdminLayout) */}
        <Route path="/admin/dashboard" element={
          <AdminRoute><AdminDashboard /></AdminRoute>
        } />
        <Route path="/admin/products" element={
          <AdminRoute><AdminProducts /></AdminRoute>
        } />
        <Route path="/admin/categories" element={
          <AdminRoute><AdminCategories /></AdminRoute>
        } />
        <Route path="/admin/orders" element={
          <AdminRoute><AdminOrders /></AdminRoute>
        } />
        <Route path="/admin/members" element={
          <AdminRoute><AdminMembers /></AdminRoute>
        } />
        <Route path="/admin/analytics" element={
          <AdminRoute><AdminAnalytics /></AdminRoute>
        } />
        <Route path="/admin/settings" element={
          <AdminRoute><AdminSettings /></AdminRoute>
        } />
        <Route path="/admin/notifications" element={
          <AdminRoute><NotificationSettings /></AdminRoute>
        } />
        <Route path="/admin/remarketing" element={
          <AdminRoute><AdminRemarketing /></AdminRoute>
        } />

        {/* 前台路由 (使用 Layout) */}
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/products" element={<Layout><ProductList /></Layout>} />
        <Route path="/products/:id" element={<Layout><ProductDetail /></Layout>} />
        <Route path="/cart" element={<Layout><ErrorBoundary><Cart /></ErrorBoundary></Layout>} />
        <Route path="/checkout" element={<Layout><ErrorBoundary><Checkout /></ErrorBoundary></Layout>} />
        <Route path="/checkout/complete/:orderNo" element={<Layout><OrderComplete /></Layout>} />
        <Route path="/order/:orderNo" element={<Layout><OrderStatus /></Layout>} />
        <Route path="/shopping-guide" element={<Layout><ShoppingGuide /></Layout>} />
        <Route path="/about" element={<Navigate to="/shopping-guide?tab=0" replace />} />
        <Route path="/privacy" element={<Navigate to="/shopping-guide?tab=5" replace />} />
        <Route path="/terms" element={<Navigate to="/shopping-guide?tab=4" replace />} />
        <Route path="/return-policy" element={<Layout><ReturnPolicy /></Layout>} />
        <Route path="/login" element={<Layout><Login /></Layout>} />
        <Route path="/member" element={<Layout><MemberCenter /></Layout>} />
        <Route path="/auth/line/callback" element={<Layout><Login /></Layout>} />
        <Route path="*" element={<Layout><NotFound /></Layout>} />
          </Routes>
        </TrackingProvider>
      </StoreProvider>
    </AuthProvider>
  );
}

export default App;
